import React, { Fragment, useState } from 'react';
import {
  Navbar,
  NavbarBrand,
} from 'reactstrap';
import logo from '../../../assets/images/logo.png';

const EndUserHeader = () => {

    return (       
      <Navbar fixed='top' color="light" light className="navbar-bg" expand="md">
        <NavbarBrand href="/"> <img src={logo}  /></NavbarBrand>
      </Navbar>          
    )
}

export default EndUserHeader;